
<div class="page">

    <div class="page-header">
        <div class="breadcrumb">
            <p-breadcrumb [model]="breadcrumbs" [home]="homeBreadcrumb"></p-breadcrumb>
        </div>
        <div class="search">
            <input pInputText type="text" (input)="filter(dt, $event)" placeholder="Search..." />           
        </div>
        <div class="actions">
            <button pButton pRipple label="New" icon="pi pi-plus" class="button-action p-button-success p-mr-2" (click)="openNew()"></button>
            <button pButton pRipple label="Delete" icon="pi pi-trash" class="button-action p-button-danger" (click)="deleteSelectedCages()" [disabled]="!selectedCages || !selectedCages.length "></button>
        </div> 
    </div>

    <div class="page-content">

        <div #calendarWrapper></div>

        <p-table #dt 
            [value]="cages"                                                                                                      
            [rows]="10" 
            [paginator]="true" 
            [globalFilterFields]="['position','qrcode','name','description','tags','status','filledAt','emptiedAt','fishWeightAverage','fishNumber','fishMortality','harvestName']"
            [rowsPerPageOptions]="[5,10,25,50,100]"
            [(selection)]="selectedCages" 
            [resizableColumns]="true"
            [reorderableColumns]="true"
            [rowHover]="true" 
            dataKey="$key"
            styleClass="p-datatable-striped"
            currentPageReportTemplate="{first} to {last} of {totalRecords}" 
            [showCurrentPageReport]="true"
            selectionMode="multiple"
            [columns]="selectedColumns"
            (onRowReorder)="reorder($event)"
            sortField="position" 
            [sortOrder]="1"
            >

            <ng-template pTemplate="colgroup">
                <colgroup>
                    <col style="max-width:10%">
                    <col style="max-width:20%">
                    <col style="min-width:10%;max-width:80%">
                    <col style="max-width:20%">
                </colgroup>
            </ng-template>
            
            <ng-template pTemplate="caption">
                <p-multiSelect [options]="cols" [(ngModel)]="selectedColumns" optionLabel="header"
                selectedItemsLabel="{0} columns selected" [style]="{minWidth: '200px'}" placeholder="Choose Columns"></p-multiSelect>
            </ng-template>

            <ng-template pTemplate="header" let-columns="columns">
                <tr>
                    <th pResizableColumn pSortableColumn="position" style="width: 8rem">
                        Order<p-sortIcon field="position"></p-sortIcon>
                    </th>
                    <th id="qrcode" style="width: 8rem" name="qrcode" pResizableColumn pReorderableColumn pSortableColumn="qrcode" [class]="includesCol('qrcode') ? 'd' : 'h'">QRCode 
                        <p-sortIcon field="name"></p-sortIcon> 
                        <p-columnFilter type="text" field="name" display="menu"></p-columnFilter> 
                    </th>
                    <th id="name" name="name" pResizableColumn pReorderableColumn pSortableColumn="name" [class]="includesCol('name') ? 'd' : 'h'">Name 
                        <p-sortIcon field="name"></p-sortIcon> 
                        <p-columnFilter type="text" field="name" display="menu"></p-columnFilter>
                    </th>
                    <th id="description" name="description" pResizableColumn pReorderableColumn [class]="includesCol('description') ? 'd' : 'h'">Description
                        <p-sortIcon field="description"></p-sortIcon> 
                        <p-columnFilter type="text" field="description" display="menu"></p-columnFilter>
                    </th>
                    <th id="tags" name="tags" pResizableColumn pReorderableColumn [class]="includesCol('tags') ? 'd' : 'h'">Tags
                        <p-sortIcon field="tags"></p-sortIcon> 
                        <p-columnFilter type="text" field="tags" display="menu"></p-columnFilter>
                    </th>

                    <th id="harvestName" name="harvestName" pResizableColumn pReorderableColumn pSortableColumn="name" [class]="includesCol('harvestName') ? 'd' : 'h'">
                        <img style="vertical-align: middle;" src="assets/images-black/ic_fishboat.png" width="24px" height="24px" [routerLink]="['/fish-management/harvests']"/> 
                        Harvest 
                        <p-sortIcon field="harvestName"></p-sortIcon> 
                        <p-columnFilter type="text" field="harvestName" display="menu"></p-columnFilter>
                    </th>


                    <th id="fishAverageWeight" name="fishAverageWeight" pResizableColumn pReorderableColumn pSortableColumn="fishAverageWeight" [class]="includesCol('fishAverageWeight') ? 'd' : 'h'">
                        Weight (avg) 
                        <p-sortIcon field="fishAverageWeight"></p-sortIcon> 
                        <p-columnFilter type="numeric" field="fishAverageWeight" display="menu"></p-columnFilter>
                    </th>

                    <th id="fishNumber" name="fishNumber" pResizableColumn pReorderableColumn pSortableColumn="fishNumber" [class]="includesCol('fishNumber') ? 'd' : 'h'">
                        Fish (nb) 
                        <p-sortIcon field="fishNumber"></p-sortIcon> 
                        <p-columnFilter type="numeric" field="fishNumber" display="menu"></p-columnFilter>
                    </th>

                    <th id="fishMortality" name="fishMortality" pResizableColumn pReorderableColumn pSortableColumn="fishMortality" [class]="includesCol('fishMortality') ? 'd' : 'h'">
                        Mortality (nb / %)
                        <p-sortIcon field="fishMortality"></p-sortIcon> 
                        <p-columnFilter type="numeric" field="fishMortality" display="menu"></p-columnFilter>
                    </th>

                    <th id="filledAt" name="filledAt" pResizableColumn pReorderableColumn pSortableColumn="filledAt" [class]="includesCol('filledAt') ? 'd' : 'h'">
                        Filled at
                        <p-sortIcon field="filledAt"></p-sortIcon> 
                        <p-columnFilter type="datetime" field="filledAt" display="menu"></p-columnFilter>
                    </th>

                    <th id="emptiedAt" name="emptiedAt" pResizableColumn pReorderableColumn pSortableColumn="emptiedAt" [class]="includesCol('emptiedAt') ? 'd' : 'h'">
                        Emptied at
                        <p-sortIcon field="emptiedAt"></p-sortIcon> 
                        <p-columnFilter type="datetime" field="emptiedAt" display="menu"></p-columnFilter>
                    </th>

                    <th id="isEnabled" name="isEnabled" pResizableColumn pReorderableColumn pSortableColumn="isEnabled" style="width: 10rem" [class]="includesCol('isEnabled') ? 'show' : 'hide'">
                        Enabled
                        <p-sortIcon field="isEnabled"></p-sortIcon> 
                        <p-columnFilter type="boolean" field="isEnabled" display="menu"></p-columnFilter>
                    </th>
                    <th pResizableColumn pReorderableColumn style="width: 8rem">
                        Actions 
                        <!-- <button type="button" pButton pRipple icon="pi pi-file-o" (click)="dt.exportCSV();" class="p-mr-2" pTooltip="CSV" tooltipPosition="bottom"></button> -->
                        <p-tableHeaderCheckbox style="float: right;margin-right:3px" class="checkbox"></p-tableHeaderCheckbox>
                    </th>
                    
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-cage let-columns="columns" let-index="rowIndex">
                <tr [pReorderableRow]="index" >
                    <td pEditableColumn>
                        <span *ngIf="isReordering && !isFilter" class="pi pi-bars" [pReorderableRowHandle]="index" style="margin-right: 1rem;"></span>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" 
                                (ngModelChange)="modelChangeFn($event, cage)"
                                [ngModel]="cage.position" 
                                (blur)="completePosition(cage)" 
                                (keydown.tab)="completePosition(cage)" 
                                (keydown.enter)="completePosition(cage)"  
                                required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{index}}
                                <!-- ( {{cage.position}} ) -->
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('qrcode') ? 'd' : 'h'">
                        <qrcode [qrdata]="cage.name" [width]="100" [errorCorrectionLevel]="'M'"></qrcode>
                    </td>

                    <td pEditableColumn [class]="includesCol('name') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="cage.name" 
                                (blur)="completeCage(cage)" 
                                (keydown.tab)="completeCage(cage)" 
                                (keydown.enter)="completeCage(cage)" 
                                 required>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{cage.name}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('description') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="text" [(ngModel)]="cage.description"  (blur)="completeCage(cage)" (keydown.tab)="completeCage(cage)" (keydown.enter)="completeCage(cage)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{cage.description}}</span>
                            
                         
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('tags') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <p-chips  id="tags" [(ngModel)]="cage.tags" [separator]="separatorExp" placeholder="tag1, tag2 tag3" (onBlur)="completeCage(cage)" (onAdd)="completeCage(cage)" (onRemove)="completeCage(cage)"></p-chips>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span style="margin-right: 5px;" *ngFor="let tag of cage.tags">
                                    <p-tag >{{tag}}</p-tag>
                                </span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <!-- (blur)="completeCage(cage)" 
                    (keydown.tab)="completeCage(cage)" 
                    (keydown.enter)="completeCage(cage)"  -->

                    <!-- (blur)="onChangeHarvest(cage, cage.harvestKey, $event)" 
                    (keydown.tab)="onChangeHarvest(cage, cage.harvestKey, $event)" 
                    (keydown.enter)="onChangeHarvest(cage, cage.harvestKey, $event)"  -->


                    <td pEditableColumn [class]="includesCol('harvestName') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <!-- <input pInputText type="text" [(ngModel)]="cage.harvestName"  (blur)="completeCage(cage)" (keydown.tab)="completeCage(cage)" (keydown.enter)="completeCage(cage)"  required>
                                (blur)="onChangeHarvest(cage, cage.harvestKey, $event)" 
                                 (keydown.tab)="onChangeHarvest(cage, cage.harvestKey, $event)" 
                                 (keydown.enter)="onChangeHarvest(cage, cage.harvestKey, $event)" 
                               (onChange)="onChangeHarvest(cage, cage.harvestKey, $event)"
                                 
                                -->
                                 <p-dropdown 
                                    appendTo="body" 
                                    [filter]="true"
                                    [showClear]="true" 
                                    [ngModel]="cage.harvestKey" 
                                    [options]="harvests" 
                                    optionLabel="name" 
                                    optionValue="$key"  

                                    (onChange)="onChangeHarvest(cage, cage.harvestKey, $event)"
                                    (blur)="completeCage(cage)" 
                                    (keydown.tab)="completeCage(cage)" 
                                    (keydown.enter)="completeCage(cage)" 
                            
                                    placeholder="Any">
                             </p-dropdown>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <!-- <span >{{ cage.harvestKey }}</span>
                                <span >{{ cage.harvestName }}</span> -->
                                <span >{{displayHarvestName(cage.harvestKey)}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('fishAverageWeight') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="number" [(ngModel)]="cage.fishAverageWeight"  (blur)="completeCage(cage)" (keydown.tab)="completeCage(cage)" (keydown.enter)="completeCage(cage)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{cage.fishAverageWeight}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('fishNumber') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="number" [(ngModel)]="cage.fishNumber"  (blur)="completeCage(cage)" (keydown.tab)="completeCage(cage)" (keydown.enter)="completeCage(cage)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{cage.fishNumber}}</span>

                                <br>
                                <br> 1000 disposal
                                <br> 2500 reserved toto
                                <br> 2500 reserved titi
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    
                    <td pEditableColumn [class]="includesCol('fishMortality') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="number" [(ngModel)]="cage.fishMortality"  (blur)="completeCage(cage)" (keydown.tab)="completeCage(cage)" (keydown.enter)="completeCage(cage)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{cage.fishMortality}} </span>
                                <span *ngIf="cage.fishNumber && cage.fishMortality">({{ cage.fishMortality / cage.fishNumber }} %)</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('filledAt') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                
                                    <p-calendar 
                                        [(ngModel)]="cage.filledAt"  
                                        [ngModelOptions]="{standalone: true}" 
                                        [showIcon]="true" 
                                        [showTime]="true" 
                                        [showSeconds]="true" 
                                        inputId="time" 
                                        [appendTo]="calendarWrapper"
                                        (onSelect)="onSelect($event,cage)" 
                                        (onBlur)="onBlur($event,cage)" 
                                        (onClose)="onClose($event,cage)"
                                      >
                                    </p-calendar>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{cage.filledAt | date: 'dd/MM/yyyy HH:mm' }}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('emptiedAt') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                
                                    <p-calendar 
                                        [(ngModel)]="cage.emptiedAt"  
                                        [ngModelOptions]="{standalone: true}" 
                                        [showIcon]="true" 
                                        [showTime]="true" 
                                        [showSeconds]="true" 
                                        inputId="time" 
                                        [appendTo]="calendarWrapper"
                                        (onSelect)="onSelect($event,cage)" 
                                        (onBlur)="onBlur($event,cage)" 
                                        (onClose)="onClose($event,cage)"
                                      >
                                    </p-calendar>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{cage.emptiedAt | date: 'dd/MM/yyyy HH:mm' }}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>


                    <td pEditableColumn [class]="includesCol('isEnabled') ? 'd' : 'h'" class="enabled" style="text-align: center;">
                        <p-inputSwitch  [(ngModel)]="cage.isEnabled" (onChange)="completeCage(cage)"></p-inputSwitch>
                    </td>

                    <td class="row-actions">
                        <button style="margin-right: 10px" pButton pRipple icon="pi pi-plus" class="p-button-rounded p-button-success p-mr-2" (click)="moveToFridge(cage)"></button>
                        <button style="margin-right: 10px" pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" (click)="editCage(cage)"></button>
                        <button style="margin-right: 10px" pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteCage(cage)"></button>
                        <p-tableCheckbox class="checkbox" [value]="cage"></p-tableCheckbox>
                        
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="summary">
                    <div class="summary-total">
                        Total: {{cages ? cages.length : 0 }} cage{{cages.length > 1? 's': ''}}
                    </div>
                    <div class="summary-export">
                        <button style="margin-right: 10px"type="button" pButton pRipple icon="pi pi-file-o" (click)="exportToCsv()" class="p-mr-2" pTooltip="CSV - Save the selected lines and columns" tooltipPosition="bottom"></button>
                        <button style="margin-right: 10px"type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS - Save all the lines and columns" tooltipPosition="bottom"></button>
                        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning p-mr-2" pTooltip="PDF - Save all the lines and columns" tooltipPosition="bottom"></button>
                    </div>
                </div>
            </ng-template>
        </p-table>

    </div>

    <div class="page-footer">
        <div class="p-d-flex">
            <!-- <button type="button" pButton pRipple icon="pi pi-filter" (click)="dt.exportCSV({selectionOnly:true})" class="p-button-info p-ml-auto" pTooltip="Selection Only" tooltipPosition="bottom"></button> -->
        </div>        
    </div>

    <!-- Dialog : confirm -->
    <p-confirmDialog [style]="{width: '450px'}">

        <ng-template pTemplate="header">
            <h3>Header Content</h3>
        </ng-template>
        <ng-template pTemplate="">
mess
        </ng-template>
        <!-- <ng-template pTemplate="footer">
            <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
            <button type="button" pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"></button>
        </ng-template> -->
        
    </p-confirmDialog>

     <!-- Dialog : Popup move -->
     <p-dialog [(visible)]="moveDialog" [style]="{width: '450px', height: '375px'}" header="Move to freezer" [modal]="true" styleClass="p-fluid" [baseZIndex]='1000'>
        

        

        <div class="p-field" style="margin-top: 10px;">
            <label><b>From</b></label>
            <span> {{ cage.name }} </span>
        </div>

        

        <div class="p-field" style="margin-top: 20px;">
            <label><b>To</b></label>
            
            <label for="location">&nbsp;&nbsp; Freezer &nbsp;&nbsp; </label>
            <img style="vertical-align: middle;" src="assets/images-black/ic_fridge.png" width="24px" height="24px" [routerLink]="['/fish-management/fridges']"/> 
            <div style="margin-top: 10px;"></div>
            <p-dropdown 
                appendTo="body" 
                [filter]="true"
                [showClear]="true" 
                [(ngModel)]="fridgeKey" 
                [options]="fridges" 
                optionLabel="name" 
                optionValue="$key"
                placeholder="Any">
            </p-dropdown>
        </div>

        <div class="p-field" style="margin-top: 10px;">
            <label for="quantity">Quantity</label>
            <input style="margin-top: 10px;" type="number" pInputText id="quantity" [(ngModel)]="quantity" required autofocus value="{{ cage.fishNumber }}"/>
            <small class="p-error" *ngIf="submitted && !cage.name">Quantity is required.</small>
        </div>


        <!-- <div class="p-field">
            <label for="description">Description</label>
            <textarea style="margin-top: 10px;" id="description" pInputTextarea [(ngModel)]="cage.description" rows="3" cols="20"></textarea>
        </div>
        <div class="p-field">
            <label for="tags" >Tags</label>
            <div style="height: 10px;">&nbsp;</div>
            <p-chips  id="tags" [(ngModel)]="cage.tags" [separator]="separatorExp" placeholder="tag1, tag2 tag3"></p-chips>
        </div>    -->
        <div class="in-out" style="margin-top: 20px;">
            <button pButton pRipple label="Cancel" icon="pi pi-times" class="button-action p-button-danger p-mr-2" (click)="hideMoveDialog()"></button>
            <button pButton pRipple label="Save" icon="pi pi-check" class="button-action p-button-success" (click)="saveCage()"></button>
        </div>
    </p-dialog>
    

    <!-- Dialog : Popup -->
    <p-dialog [(visible)]="cageDialog" [style]="{width: '450px', height: '450px'}" header="Cage" [modal]="true" styleClass="p-fluid" [baseZIndex]='1000'>
        <div class="p-field" style="margin-top: 10px;">
            <label for="title">Name</label>
            <input style="margin-top: 10px;" type="text" pInputText id="name" [(ngModel)]="cage.name" required autofocus />
            <small class="p-error" *ngIf="submitted && !cage.name">Name is required.</small>
        </div>
        <div class="p-field">
            <label for="description">Description</label>
            <textarea style="margin-top: 10px;" id="description" pInputTextarea [(ngModel)]="cage.description" rows="3" cols="20"></textarea>
        </div>
        <div class="p-field">
            <label for="tags" >Tags</label>
            <div style="height: 10px;">&nbsp;</div>
            <p-chips  id="tags" [(ngModel)]="cage.tags" [separator]="separatorExp" placeholder="tag1, tag2 tag3"></p-chips>
        </div>   
        <div class="in-out" style="margin-top: 20px;">
            <button pButton pRipple label="Cancel" icon="pi pi-times" class="button-action p-button-danger p-mr-2" (click)="hideDialog()"></button>
            <button pButton pRipple label="Save" icon="pi pi-check" class="button-action p-button-success" (click)="saveCage()"></button>
        </div>
    </p-dialog>

    <!-- { field: 'harvestKey', header: 'Harvest' },
                    { field: 'fishAverageWeight', header: 'Weight (avg)' },
                    { field: 'fishNumber', header: 'Fish (nb)' },
                    { field: 'fishMortality', header: 'Mortality (nb / %)' },
                    { field: 'filledAt', header: 'Filled at' },
                    { field: 'emptiedAt', header: 'Emptied at' },
     -->
    

</div>






